<template>
	<div>
		<header-page
			name="accounting-periods"
			:title="title"
		/>
		<v-treeview class="pa-5" :items="items"></v-treeview>
	</div>
</template>

<script>
	function created() {
		this.loadItems();
	}

	async function loadItems() {
		try {
			const { data: detail } = await this.$http.get(
				`register/${this.id}/${this.subsidiaryId}/detail`);
			const detailKeys = Object.keys(detail);
			this.items = this.objectToChildren(detail, detailKeys);
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		}
	}

	function objectToChildren(detail, keys) {
		return keys.reduce((acum, key) => {
			const acumItem = {
				id: acum.length + 1,
			};
			if (detail[key] && typeof detail[key] === 'object') {
				const detailItemKeys = Object.keys(detail[key]);
				acumItem.name = `${key}:`;
				acumItem.children = objectToChildren(detail[key], detailItemKeys);
			} else {
				acumItem.name = `${key}: ${detail[key]}`;
			}
			acum.push(acumItem);
			return acum;
		}, []);
	}

	function title() {
		const { periodName, CODASI } = this.$route.query;
		return this.subsidiaryId ?
			`${this.subsidiaryName} / ${periodName} / ${CODASI} / ${this.$route.meta.title}` :
			this.$route.meta.title;
	}

	function data() {
		return {
			items: [],
		};
	}

	export default {
		name: 'page-record-detail',
		computed: {
			title,
		},
		created,
		data,
		methods: {
			loadItems,
			objectToChildren,
		},
		props: {
			id: [Number, String],
			periodId: [Number, String],
			subsidiaryId: [Number, String],
			subsidiaryName: String,
		},
	};
</script>



// WEBPACK FOOTER //
// src/pages/records/page-record-detail.vue